import axios from "axios";
import { baseURL } from "../../../base-url.js";

export default {
  async deleteTransaction({ commit }, transactionId) {
    const token = localStorage.getItem("jwt");
  
    try {
      const response = await axios.delete(`${baseURL}/transaction/deleteTransaction`, {
        params: { id: transactionId },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      if (response.status >= 200 && response.status < 300) commit('product/salesStockChanged', null, { root: true });
      return response;
    } catch (error) {
      return error.response;
    }
  },

  async fetchCardTransactions(
    { commit },
    { salonId, startDate, endDate, page = 0, size = 10 }
  ) {
    const token = localStorage.getItem('jwt')
    try {
      const response = await axios.get(
        `${baseURL}/transaction/getCardTransactions`,
        {
          params: { salonId, startDate, endDate, page, size },
          headers: { Authorization: `Bearer ${token}` }
        }
      )

      const embeddedKey = Object.keys(response.data._embedded || {})[0] || null
      const list = embeddedKey ? response.data._embedded[embeddedKey] : []

      commit('setCardTransactions', {
        list,
        page: {
          page: response.data.page.number,
          size: response.data.page.size,
          totalPages: response.data.page.totalPages,
          totalElements: response.data.page.totalElements
        }
      })

      return response.data
    } catch (error) {
      return error.response
    }
  }
  
}
